<div class="scene-tree">
  <div class="view-preset-grid" style="margin-top: 4px">
    <app-button
      (click)="startDistance()"
      variant="secondary"
      [title]="'measurementsPanel.distance' | transloco"
    >
      {{ 'measurementsPanel.distance' | transloco }}
    </app-button>
    <app-button
      (click)="startAngle()"
      variant="secondary"
      [title]="'measurementsPanel.angle' | transloco"
    >
      {{ 'measurementsPanel.angle' | transloco }}
    </app-button>
    <app-button
      (click)="startPoint()"
      variant="secondary"
      [title]="'measurementsPanel.point' | transloco"
    >
      {{ 'measurementsPanel.point' | transloco }}
    </app-button>
    <app-button
      (click)="startHeight()"
      variant="secondary"
      [title]="'measurementsPanel.height' | transloco"
    >
      {{ 'measurementsPanel.height' | transloco }}
    </app-button>
    <app-button
      (click)="startCircle()"
      variant="secondary"
      [title]="'measurementsPanel.circle' | transloco"
    >
      {{ 'measurementsPanel.circle' | transloco }}
    </app-button>
    <app-button
      (click)="startAzimuth()"
      variant="secondary"
      [title]="'measurementsPanel.azimuth' | transloco"
    >
      {{ 'measurementsPanel.azimuth' | transloco }}
    </app-button>
    <app-button
      (click)="startArea()"
      variant="secondary"
      [title]="'measurementsPanel.area' | transloco"
    >
      {{ 'measurementsPanel.area' | transloco }}
    </app-button>
    <app-button
      (click)="startProfile()"
      variant="secondary"
      [title]="'measurementsPanel.profile' | transloco"
    >
      {{ 'measurementsPanel.profile' | transloco }}
    </app-button>
    <app-button
      (click)="startVolume()"
      variant="secondary"
      [title]="'measurementsPanel.box' | transloco"
    >
      {{ 'measurementsPanel.box' | transloco }}
    </app-button>
    <app-button
      (click)="startSphereVolume()"
      variant="secondary"
      [title]="'measurementsPanel.sphere' | transloco"
    >
      {{ 'measurementsPanel.sphere' | transloco }}
    </app-button>
    <app-button
      (click)="startAnnotation()"
      variant="secondary"
      [title]="'measurementsPanel.annotation' | transloco"
    >
      {{ 'measurementsPanel.annotation' | transloco }}
    </app-button>
  </div>
  <div class="scene-group" *ngIf="sceneMeasurements().length || sceneVolumes().length">
    <div class="group-title">{{ 'measurementsPanel.measurements' | transloco }}</div>
    <div
      class="scene-item"
      *ngFor="let m of sceneMeasurements()"
      [class.selected]="selectedMeasurementId() === m.id"
      (click)="selectMeasurement('measurement', m.id)"
    >
      <span
        class="vis"
        [class.off]="!m.visible"
        [title]="'measurementsPanel.toggleVisibility' | transloco"
        (click)="toggleMeasurementVisibility('measurements', m.id); $event.stopPropagation()"
      >
        <svg
          *ngIf="m.visible"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        <svg
          *ngIf="!m.visible"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.77 21.77 0 0 1 5.06-6.94"
          />
          <path d="M1 1l22 22" />
          <path d="M9.53 9.53a3 3 0 0 0 4.24 4.24" />
          <path
            d="M12 4a10.94 10.94 0 0 1 7.94 3.34 21.77 21.77 0 0 1 3.06 4.66c-.824 1.537-1.84 3.029-3.06 4.66"
          />
        </svg>
      </span>
      <span class="name">{{ m.name }}</span>
      <span
        class="del"
        [title]="'measurementsPanel.deleteMeasurement' | transloco"
        (click)="removeMeasurement('measurement', m.id); $event.stopPropagation()"
      >
        &times;
      </span>
    </div>
    <div
      class="scene-item"
      *ngFor="let v of sceneVolumes()"
      [class.selected]="selectedMeasurementId() === v.id"
      (click)="selectMeasurement('volume', v.id)"
    >
      <span
        class="vis"
        [class.off]="!v.visible"
        [title]="'measurementsPanel.toggleVisibility' | transloco"
        (click)="toggleMeasurementVisibility('volumes', v.id); $event.stopPropagation()"
      >
        <svg
          *ngIf="v.visible"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        <svg
          *ngIf="!v.visible"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.77 21.77 0 0 1 5.06-6.94"
          />
          <path d="M1 1l22 22" />
          <path d="M9.53 9.53a3 3 0 0 0 4.24 4.24" />
          <path
            d="M12 4a10.94 10.94 0 0 1 7.94 3.34 21.77 21.77 0 0 1 3.06 4.66c-.824 1.537-1.84 3.029-3.06 4.66"
          />
        </svg>
      </span>
      <span class="name">{{ v.name }}</span>
      <span
        class="del"
        [title]="'measurementsPanel.deleteVolume' | transloco"
        (click)="removeMeasurement('volume', v.id); $event.stopPropagation()"
      >
        &times;
      </span>
    </div>
  </div>
  <div class="scene-group" *ngIf="sceneProfiles().length">
    <div class="group-title">{{ 'measurementsPanel.profiles' | transloco }}</div>
    <div
      class="scene-item"
      *ngFor="let p of sceneProfiles(); trackBy: trackById"
      [class.selected]="selectedMeasurementId() === p.id"
      (click)="profile2DClick.emit({ event: $event, id: p.id })"
    >
      <span
        class="vis"
        [class.off]="!p.visible"
        [title]="'measurementsPanel.toggleVisibility' | transloco"
        (click)="toggleMeasurementVisibility('profiles', p.id); $event.stopPropagation()"
      >
        <svg
          *ngIf="p.visible"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        <svg
          *ngIf="!p.visible"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.77 21.77 0 0 1 5.06-6.94"
          />
          <path d="M1 1l22 22" />
          <path d="M9.53 9.53a3 3 0 0 0 4.24 4.24" />
          <path
            d="M12 4a10.94 10.94 0 0 1 7.94 3.34 21.77 21.77 0 0 1 3.06 4.66c-.824 1.537-1.84 3.029-3.06 4.66"
          />
        </svg>
      </span>
      <span class="name">{{ p.name }}</span>
      <span
        class="del"
        [title]="'measurementsPanel.deleteProfile' | transloco"
        (click)="removeMeasurement('profile', p.id); $event.stopPropagation()"
      >
        &times;
      </span>
    </div>
  </div>
  <div class="scene-group" *ngIf="annotationService.annotations().length">
    <div class="group-title">{{ 'measurementsPanel.annotations' | transloco }}</div>
    <div
      class="scene-item"
      *ngFor="let annotation of annotationService.annotations()"
      [class.selected]="selectedMeasurementId() === annotation.uuid"
      (click)="selectMeasurement('annotation', annotation.uuid)"
    >
      <span
        class="vis"
        [class.off]="!annotation.visible"
        [title]="'measurementsPanel.toggleVisibility' | transloco"
        (click)="toggleAnnotationVisibility(annotation.uuid); $event.stopPropagation()"
      >
        <svg
          *ngIf="annotation.visible"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        <svg
          *ngIf="!annotation.visible"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.77 21.77 0 0 1 5.06-6.94"
          />
          <path d="M1 1l22 22" />
          <path d="M9.53 9.53a3 3 0 0 0 4.24 4.24" />
          <path
            d="M12 4a10.94 10.94 0 0 1 7.94 3.34 21.77 21.77 0 0 1 3.06 4.66c-.824 1.537-1.84 3.029-3.06 4.66"
          />
        </svg>
      </span>
      <span class="name">{{ annotation.title }}</span>
      <span
        class="del"
        [title]="'measurementsPanel.deleteAnnotation' | transloco"
        (click)="removeAnnotation(annotation.uuid); $event.stopPropagation()"
      >
        &times;
      </span>
    </div>
  </div>

  <!-- Measurement Properties -->
  <div *ngIf="selectedMeasurementDetails" class="measurement-properties">
    <div class="divider">
      <span>{{ 'measurementsPanel.properties' | transloco }}</span>
    </div>
    <div class="properties-content">
      <!-- Coordinates Table -->
      <div
        *ngIf="
          selectedMeasurementDetails.coordinates && selectedMeasurementDetails.coordinates.length
        "
      >
        <table class="measurement_value_table">
          <tr>
            <th></th>
            <th>x</th>
            <th>y</th>
            <th>z</th>
          </tr>
          <tr *ngFor="let coord of selectedMeasurementDetails.coordinates; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ coord.x | number: '1.2-2' }}</td>
            <td>{{ coord.y | number: '1.2-2' }}</td>
            <td>{{ coord.z | number: '1.2-2' }}</td>
          </tr>
        </table>
      </div>

      <!-- Distance measurements -->
      <div
        *ngIf="selectedMeasurementDetails.distances && selectedMeasurementDetails.distances.length"
      >
        <table class="measurement_value_table">
          <tr *ngFor="let dist of selectedMeasurementDetails.distances; let i = index">
            <th>{{ i === 0 ? ('measurementsPanel.distanceLabel' | transloco) : '' }}</th>
            <td>{{ dist | number: '1.3-3' }}</td>
          </tr>
          <tr *ngIf="selectedMeasurementDetails.totalDistance !== undefined">
            <th>{{ 'measurementsPanel.total' | transloco }}</th>
            <td>
              <strong>{{ selectedMeasurementDetails.totalDistance | number: '1.3-3' }}</strong>
            </td>
          </tr>
        </table>
      </div>

      <!-- Area -->
      <div *ngIf="selectedMeasurementDetails.area">
        <table class="measurement_value_table">
          <tr>
            <th>{{ 'measurementsPanel.areaLabel' | transloco }}</th>
            <td>{{ selectedMeasurementDetails.area | number: '1.3-3' }}</td>
          </tr>
        </table>
      </div>

      <!-- Angles -->
      <div *ngIf="selectedMeasurementDetails.angles && selectedMeasurementDetails.angles.length">
        <table class="measurement_value_table">
          <tr *ngFor="let angle of selectedMeasurementDetails.angles">
            <th>{{ angle.label }}:</th>
            <td>{{ angle.value | number: '1.2-2' }}°</td>
          </tr>
        </table>
      </div>

      <!-- Volume -->
      <div *ngIf="selectedMeasurementDetails.volume !== undefined">
        <table class="measurement_value_table">
          <tr>
            <th>{{ 'measurementsPanel.volumeLabel' | transloco }}</th>
            <td>{{ selectedMeasurementDetails.volume | number: '1.3-3' }}</td>
          </tr>
          <tr *ngIf="selectedMeasurementDetails.dimensions">
            <th>{{ 'measurementsPanel.dimensions' | transloco }}</th>
            <td>
              {{ selectedMeasurementDetails.dimensions.x | number: '1.2-2' }} ×
              {{ selectedMeasurementDetails.dimensions.y | number: '1.2-2' }} ×
              {{ selectedMeasurementDetails.dimensions.z | number: '1.2-2' }}
            </td>
          </tr>
        </table>
      </div>

      <!-- Height -->
      <div *ngIf="selectedMeasurementDetails.height !== undefined">
        <table class="measurement_value_table">
          <tr>
            <th>{{ 'measurementsPanel.heightLabel' | transloco }}</th>
            <td>{{ selectedMeasurementDetails.height | number: '1.3-3' }}</td>
          </tr>
        </table>
      </div>

      <!-- Circle -->
      <div *ngIf="selectedMeasurementDetails.radius !== undefined">
        <table class="measurement_value_table">
          <tr>
            <th>{{ 'measurementsPanel.radius' | transloco }}</th>
            <td>{{ selectedMeasurementDetails.radius | number: '1.3-3' }}</td>
          </tr>
          <tr *ngIf="selectedMeasurementDetails.circumference !== undefined">
            <th>{{ 'measurementsPanel.circumference' | transloco }}</th>
            <td>{{ selectedMeasurementDetails.circumference | number: '1.3-3' }}</td>
          </tr>
        </table>
      </div>

      <!-- Annotation Properties -->
      <div *ngIf="selectedMeasurementType() === 'annotation'">
        <!-- Position -->
        <div *ngIf="selectedMeasurementDetails.position">
          <table class="measurement_value_table">
            <tr>
              <th colspan="3">{{ 'measurementsPanel.position' | transloco }}</th>
            </tr>
            <tr>
              <td>{{ selectedMeasurementDetails.position.x | number: '1.3-3' }}</td>
              <td>{{ selectedMeasurementDetails.position.y | number: '1.3-3' }}</td>
              <td>{{ selectedMeasurementDetails.position.z | number: '1.3-3' }}</td>
            </tr>
          </table>
        </div>

        <!-- Title (editable) -->
        <div class="annotation-field">
          <div class="heading">{{ 'measurementsPanel.title' | transloco }}</div>
          <div
            class="annotation-editable"
            contenteditable="true"
            [textContent]="
              selectedMeasurementDetails.title || ('measurementsPanel.annotationTitle' | transloco)
            "
            (blur)="onAnnotationTitleChange($any($event.target).textContent)"
          ></div>
        </div>

        <!-- Description (editable) -->
        <div class="annotation-field">
          <div class="heading">{{ 'measurementsPanel.description' | transloco }}</div>
          <div
            class="annotation-editable"
            contenteditable="true"
            [textContent]="
              selectedMeasurementDetails.description ||
              ('measurementsPanel.description' | transloco)
            "
            (blur)="onAnnotationDescriptionChange($any($event.target).textContent)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
